<app-header></app-header>
<app-sub-header [title]="'Portal do Servidor - Praça de Atendimento'" [color]="'var(--secondary)'">
</app-sub-header>
<div class="container">
  <main>
    <router-outlet></router-outlet>
  </main>
</div>
<app-footer></app-footer>